import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiCountry, ApiLocality, ApiPlace, ApiRegion } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'

type PlaceResponse = { data: ApiPlace; included: (ApiRegion | ApiLocality | ApiCountry)[] }

export const getPlacesById = (id: string) =>
  createApiAction('getPlacesById', dispatch =>
    dispatch<PlaceResponse>({ method: 'GET', endpoint: v2Path(urlEscaped`/api/v2/places/${id}`, { include: 'region,country,locality' }) })
  )

export const getPlacesByLocation = (request: { latitude: number; longitude: number }) =>
  createApiAction('getPlacesByLocation', dispatch =>
    dispatch<PlaceResponse>({
      method: 'GET',
      endpoint: v2Path('/api/v2/places/by_location', { ...request, include: 'region,country,locality' }),
    })
  )
